import { useAuth } from "../auth/AuthContext";
import CouponsPage from "./CouponsPage";

export default function WalletPage() {
  const { customer } = useAuth();
  return <CouponsPage user={customer} />;
}
